export default __webpack_public_path__ + "static/media/holistic_management_portal.44954e0a.png";